"use strict";
HTMLElement.prototype.siblings = function siblings(selector) {
    if (this.parentNode === null) {
        return [];
    }
    const result = [];
    Array.from(this.parentNode.children).forEach((value) => {
        const elm = value;
        if (elm === this || !(elm instanceof HTMLElement)) {
            return;
        }
        if (selector === undefined || elm.matches(selector)) {
            result.push(elm);
        }
    });
    return result;
};
//# sourceMappingURL=Siblings.js.map